import type { TypePolicies } from '../../../../utils';
import { cursorPaginationFieldPolicy } from '../../../../utils/policies';
import { type FieldPolicyWithVars } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  VersionStackAsset: {
    fields: {
      versionTimeline: cursorPaginationFieldPolicy(
        ['includeMinorVersions'],
        false,
        (node) => node?.minorVersion?.__ref ?? node?.asset?.__ref
      ) as FieldPolicyWithVars as TypePolicies['VersionStackAsset'],
    },
  },
};
